import routerOptions0 from "/Users/noah/Documents/websites/ch4pathways-org-website-frontend/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions0,
}